import React from 'react';
import { usePartialState  } from '@tencent/dz-models';
import { useLoadThirdScript } from 'src/hooks';
import { ImpCoreModel } from 'src/models';
import { report } from 'src/helper';


export const useTcaptcha = (model: ImpCoreModel) => {
  const [, consultModel] = usePartialState(() => model.getConsultModel());

  const { loadThirdPart } = useLoadThirdScript({
    scriptId: 'TCaptcha',
    src: 'https://ssl.captcha.qq.com/TCaptcha.js',
  });

  React.useEffect(() => {
    if (consultModel.isLimited) {
      loadThirdPart(() => {
        const captcha1 = new window.TencentCaptcha(
          '2088699654',
          ((res: any) => {
            if (res.ret === 0) {
              consultModel.setIsLimited(false);
            }
          }),
        );
        captcha1.show();
      });
      report.exposure({
        module_type: 'page_initialization',
        module_chinese_type: '页面初始化',
        module_value: '',
        module_id: '',
        element_type: 'verification',
        element_chinese_type: '验证码',
        element_id: '',
      });
    }
  }, [consultModel.isLimited]);

  return consultModel.isLimited;
};
